import { render, staticRenderFns } from "./SelectionCard.vue?vue&type=template&id=60d947b3"
import script from "./SelectionCard.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectionCard.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports